import { Loader } from '@googlemaps/js-api-loader'
import React, { ReactNode, useContext, useEffect, useMemo, useState } from 'react'
import { env } from '../env'

export type GoogleMaps = Awaited<ReturnType<InstanceType<typeof Loader>['load']>>['maps']

export interface GoogleMapsClickEvent {
  latLng: {
    lat: () => number
    lng: () => number
  }
}

interface Props {
    children: ReactNode
}

interface ContextValues {
    Map: GoogleMaps['Map']
    Circle: GoogleMaps['Circle']
    AdvancedMarkerElement: GoogleMaps['marker']['AdvancedMarkerElement']
    geocoder: InstanceType<GoogleMaps['Geocoder']>
}

const Context = React.createContext<ContextValues>({} as never)

export const useMap = () => {
    const context = useContext(Context)
    if (!context) {
        throw new Error('useMap must be used within a MapProvider')
    }
    return context
}

const MapProvider: React.FC<Props> = ({ children }) => {

    const [Map, setMap] = useState<GoogleMaps['Map']>()
    const [Circle, setCircle] = useState<GoogleMaps['Circle']>()
    const [AdvancedMarkerElement, setAdvancedMarkerElement] = useState<GoogleMaps['marker']['AdvancedMarkerElement']>()
    const [geocoder, setGeocoder] = useState<InstanceType<GoogleMaps['Geocoder']>>()

    useEffect(() => {
        const loader = new Loader({ apiKey: env.mapsApiKey as string })

        // tslint:disable
        loader
            .importLibrary('maps')
            .then(({ Map, Circle }) => {
                setMap(() => Map)
                setCircle(() => Circle)
            })

        loader
            .importLibrary('marker')
            .then(({ AdvancedMarkerElement }) => setAdvancedMarkerElement(() => AdvancedMarkerElement))

        loader
            .importLibrary('geocoding')
            .then(({ Geocoder }) => setGeocoder(new Geocoder()))
        // tslint:enable
    }, [])

    const value = useMemo(
        () => ({
            Map: Map as GoogleMaps['Map'],
            Circle: Circle as GoogleMaps['Circle'],
            AdvancedMarkerElement: AdvancedMarkerElement as GoogleMaps['marker']['AdvancedMarkerElement'],
            geocoder: geocoder as InstanceType<GoogleMaps['Geocoder']>,
        }),
        [Map, Circle, AdvancedMarkerElement, geocoder]
    )

    return <Context.Provider value={value}>{children}</Context.Provider>
}

export default MapProvider


// WEBPACK FOOTER //
// ./src/context/MapContext.tsx